'use client';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import { ShowcaseCopyContext, translateShowcaseNode } from '../translation';
import { Me } from './reference-brands';
import {
  hf,
  Render_sf,
  Render_cf,
  Render_lf,
  Render_uf,
  Render_df,
  Render_pf,
} from './deliverable-previews';
import { referenceBrands } from './workflow-facts';
import { Render_of } from './sell-market-animation';
import { ProgressRing, ShowcaseSpinner } from './playback-controls';
export function gf(e) {
  let t = Me[e],
    n = t[0],
    r = t[t.length - 1];
  return n && r
    ? {
        paper: n,
        ink: r,
      }
    : hf[e];
}
export function ProductionBrandChip({ brand: e }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let { paper: t, ink: n } = gf(e),
    r = referenceBrands[e].name.toUpperCase(),
    i = e === 'orvieto',
    a = i ? 62 : 46;
  return (
    <React.Fragment>
      <svg viewBox={`0 0 ${a} 13`} aria-hidden={!0} className={'ref-logo'}>
        <rect width={a} height={'13'} rx={'1'} fill={t} />
        <text
          x={a / 2}
          y={'8.7'}
          textAnchor={'middle'}
          fill={n}
          fontFamily={"Georgia, 'Times New Roman', serif"}
          fontSize={'5.4'}
          letterSpacing={i ? 0.9 : 1.2}
        >
          {translateShowcaseNode(showcaseCopy, r)}
        </text>
      </svg>
      <span className={'sr-only'}>
        {translateShowcaseNode(showcaseCopy, referenceBrands[e].name)}
      </span>
    </React.Fragment>
  );
}
export const vf = {
  document: {
    badge: 'DOC',
    color: 'text-sky-500',
  },
  file: {
    badge: 'FILE',
    color: 'text-zinc-500',
  },
  image: {
    badge: 'IMG',
    color: 'text-fuchsia-500',
  },
  pdf: {
    badge: 'PDF',
    color: 'text-red-500',
  },
  presentation: {
    badge: 'PPT',
    color: 'text-orange-600',
  },
  spreadsheet: {
    badge: 'XLS',
    color: 'text-emerald-600',
  },
  video: {
    badge: 'VID',
    color: 'text-rose-500',
  },
  model: {
    badge: '3D',
    color: 'text-violet-500',
  },
};
export function FileTypeIcon({
  kind: e,
  className: t = 'h-7 w-6',
  detail: n = !0,
}) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = vf[e];
  return (
    <svg
      aria-hidden={!0}
      viewBox={'0 0 48 56'}
      className={`shrink-0 ${r.color} ${t}`}
    >
      <path
        d={'M8 2h21l11 11v35a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6V8a6 6 0 0 1 6-6Z'}
        fill={'currentColor'}
        opacity={'0.2'}
      />
      <path
        d={
          'M8 2h20v9a5 5 0 0 0 5 5h7v32a6 6 0 0 1-6 6H8a6 6 0 0 1-6-6V8a6 6 0 0 1 6-6Z'
        }
        fill={'currentColor'}
        opacity={'0.82'}
      />
      <path d={'m29 2 11 11h-7a4 4 0 0 1-4-4V2Z'} fill={'currentColor'} />
      <rect
        x={'6'}
        y={'31'}
        width={'38'}
        height={'16'}
        rx={'4'}
        fill={'currentColor'}
      />
      {translateShowcaseNode(
        showcaseCopy,
        n ? (
          <text
            x={'25'}
            y={'42'}
            textAnchor={'middle'}
            fill={'var(--background)'}
            fontSize={'8'}
            fontWeight={'800'}
            fontFamily={'ui-sans-serif, system-ui, sans-serif'}
          >
            {translateShowcaseNode(showcaseCopy, r.badge)}
          </text>
        ) : null
      )}
      <path
        d={'M9 21h18M9 26h13'}
        stroke={'currentColor'}
        strokeOpacity={'0.7'}
        strokeWidth={'2'}
        strokeLinecap={'round'}
      />
    </svg>
  );
}
export const deliverableFiles = [
  {
    name: 'tote-directions.png',
    kind: 'Renders',
    file: 'image',
    Thumb: Render_of,
  },
  {
    name: 'tote-tech-pack-v3.pdf',
    kind: 'Tech packs',
    file: 'pdf',
    Thumb: Render_sf,
  },
  {
    name: 'tote-costing.sheet',
    kind: 'Spreadsheets',
    file: 'spreadsheet',
    Thumb: Render_cf,
  },
  {
    name: 'line-review.pptx',
    kind: 'Decks',
    file: 'presentation',
    Thumb: Render_lf,
  },
  {
    name: 'supplier-brief.docx',
    kind: 'Documents',
    file: 'document',
    Thumb: Render_uf,
  },
  {
    name: 'tote.glb',
    kind: '3D models',
    file: 'model',
    Thumb: Render_df,
  },
  {
    name: 'tote-launch.mp4',
    kind: 'Video',
    file: 'video',
    Thumb: Render_pf,
  },
  {
    name: 'campaign-film.mp4',
    kind: 'Long jobs',
    file: 'video',
    Thumb: null,
  },
];
export const xf = 200;
export const Sf = 420;
export const Cf = 520;
export const wf = xf + deliverableFiles.length * Sf + Cf + 900;
export const reference_facts_a = [
  {
    kind: 'Renders',
    detail: 'Product shots, angles and campaign images',
  },
  {
    kind: 'Tech packs',
    detail: 'Sketches, specs, materials and colorways',
  },
  {
    kind: 'Spreadsheets',
    detail: 'Costings and BOMs with working formulas',
  },
  {
    kind: 'Decks',
    detail: 'Pitches and lookbooks as PPTX or PDF',
  },
  {
    kind: 'Documents',
    detail: 'Briefs, reports and brand guidelines',
  },
  {
    kind: '3D models',
    detail: 'Products you can turn and inspect',
  },
  {
    kind: 'Video',
    detail: 'Launch clips, with sound',
  },
  {
    kind: 'Long jobs',
    detail: 'Run in the background; IMAI tells you when they\u2019re done',
  },
];
export const u = reference_facts_a;
export const Tf = (e) => u.find((t) => t.kind === e)?.detail ?? '';
export function DeliverableFile({ file: e, index: t, t: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = xf + t * Sf,
    i = n - r - Cf,
    a = e.Thumb !== null && i >= 0,
    Component_o = e.Thumb;
  return (
    <figure
      data-on={String(n >= r)}
      className={
        'pd-pop m-0 flex min-w-0 flex-col overflow-hidden rounded-[10px] bg-[var(--panel)] shadow-[0_0_0_1px_var(--border)]'
      }
    >
      <div
        className={
          'relative aspect-[4/3] overflow-hidden border-b border-[var(--line)] bg-[var(--canvas)]'
        }
      >
        <div
          className={`absolute inset-0 grid place-items-center transition-opacity duration-300 ${a ? 'opacity-0' : 'opacity-100'}`}
        >
          <FileTypeIcon kind={e.file} className={'h-12 w-10 opacity-90'} />
        </div>
        {translateShowcaseNode(
          showcaseCopy,
          Component_o ? (
            <div
              data-on={String(a)}
              className={'pd-in absolute inset-0'}
              aria-hidden={!0}
            >
              <Component_o t={Math.max(0, i)} />
            </div>
          ) : null
        )}
        {translateShowcaseNode(
          showcaseCopy,
          a ? null : (
            <span
              className={
                'bg-background/90 absolute right-1.5 bottom-1.5 grid size-5 place-items-center rounded-full bg-[var(--background)] shadow-[0_0_0_1px_var(--border)]'
              }
            >
              {translateShowcaseNode(
                showcaseCopy,
                Component_o === null && n >= r + Cf ? (
                  <ProgressRing
                    value={0.62}
                    on={!0}
                    className={'text-ink size-3.5'}
                  />
                ) : (
                  <ShowcaseSpinner className={'text-ink-3 size-3'} />
                )
              )}
            </span>
          )
        )}
      </div>
      <figcaption className={'flex min-w-0 flex-col gap-0.5 px-2.5 py-2'}>
        <span className={'flex min-w-0 items-center gap-1.5'}>
          <FileTypeIcon kind={e.file} className={'h-4 w-3.5'} detail={!1} />
          <span className={'text-ink truncate font-mono text-[12px]'}>
            {translateShowcaseNode(showcaseCopy, e.name)}
          </span>
        </span>
        <span className={'text-ink-4 truncate text-[12px] leading-4'}>
          {translateShowcaseNode(
            showcaseCopy,
            Component_o
              ? e.kind
              : 'Running \xB7 IMAI tells you when it\u2019s done'
          )}
        </span>
      </figcaption>
    </figure>
  );
}
